import { TemplateConfig } from '../types';

export const jobContinueSpreadConfig: TemplateConfig = {
  id: 'job-continue-spread',
  name: '这份工作该继续么',
  description: '分析是否继续当前工作以及下一份工作的情况',
  cardCount: 5,
  
  fieldDefaults: {
    title: '这份工作该继续么',
    customerQuestion: '分析这份工作应不应该继续，还是找下一份工作比较好',
    cardPlaceholders: [
      '请输入第 1 列第 1 张牌',
      '请输入第 3 列第 1 张牌',
      '请输入第 1 列第 2 张牌',
      '请输入第 3 列第 2 张牌',
      '请输入第 2 列第 1 张牌'
    ],
    cardInfos: [
      '这份工作的发展空间',
      '当前的领导对我的评价',
      '下一份工作的情况如何',
      '下一份工作的情况如何',
      '下一份工作的情况如何'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#722ed1',
    backgroundColor: '#f9f0ff',
    icon: '💼'
  }
};
